import { requestApi } from '@app/api';
import { withTemplate } from '@app/api/paths';
import { CopyAttachment } from '@app/store/transport-layer/types/copyAttachment';

export interface copyRequesterAttachmentResponse {
  attachments: CopyAttachment[];
}

export function copyTemplateRequesterAttachments(workspaceId: string, templateId: string) {
  return requestApi<copyRequesterAttachmentResponse>({
    method: 'POST',
    url: withTemplate(`/workspaces/${workspaceId}/templates/${templateId}/attachments/copy`),
    credentials: true,
  }).then((response) => response.data);
}
